[
  {
    "id": "generic",
    "label": "General",
    "description": "Balanced positioning. Send to anyone without tailoring.",
    "headline": "Backend Engineer · Java 17 · Spring Boot",
    "targetRoles": [
      "Backend Engineer",
      "Java Developer",
      "Software Engineer"
    ],
    "files": {
      "pdf": "Ravi_Teja_Sandram_Backend_Engineer.pdf",
      "docx": "Ravi_Teja_Sandram_Backend_Engineer.docx"
    },
    "bytes": {
      "pdf": 75861,
      "docx": 11592
    }
  },
  {
    "id": "fulltime",
    "label": "Full-time",
    "description": "Emphasises ownership, progression, and engineering standards.",
    "headline": "Backend Engineer · Java 17 · Spring Boot",
    "targetRoles": [
      "Backend Engineer",
      "Java Engineer",
      "Software Engineer II"
    ],
    "files": {
      "pdf": "Ravi_Teja_Sandram_Backend_Engineer_FullTime.pdf",
      "docx": "Ravi_Teja_Sandram_Backend_Engineer_FullTime.docx"
    },
    "bytes": {
      "pdf": 79455,
      "docx": 11986
    }
  },
  {
    "id": "contract",
    "label": "Contract",
    "description": "Skills-forward. Emphasises stack match and zero ramp-up.",
    "headline": "Java · Spring Boot · Cloud — Contract",
    "targetRoles": [
      "Java Contractor",
      "Spring Boot Developer",
      "Backend Consultant"
    ],
    "files": {
      "pdf": "Ravi_Teja_Sandram_Java_Spring_Contract.pdf",
      "docx": "Ravi_Teja_Sandram_Java_Spring_Contract.docx"
    },
    "bytes": {
      "pdf": 79497,
      "docx": 12030
    }
  }
]
